'use client';

import { useContext } from 'react';

import {
  PostDetailModalContext,
  type PostDetailModalContextValue,
} from './context';

/**
 * Imperative opener for the shared post-detail modal. Falls back to a no-op +
 * console warning outside a `PostDetailModalProvider` — keeps isolated surfaces
 * (storybook, tests) callable without forcing every mount tree to wrap.
 */
export function usePostDetailModal(): PostDetailModalContextValue {
  const ctx = useContext(PostDetailModalContext);
  if (ctx) return ctx;
  return {
    openPostDetail: input => {
      console.warn(
        '[usePostDetailModal] No PostDetailModalProvider in tree — open dropped',
        input.postId,
      );
    },
    closePostDetail: () => {},
  };
}
